export default __webpack_public_path__ + "images/PR.9eaba90.png";